import * as React from 'react';
import { compose, withProps } from 'recompose';
import { skin, OemProps } from 'ui/styles/skin';

const oneMinute = 60 * 1000;

export type Props = {
    baseTime: number;
    segmentWidth: number;
    segmentHeight: number;
    segmentMargin: number;
    minutesPerSegment: number;
    segments: number;
    streamPosition: number;
    playing: boolean;
};

const style: React.CSSProperties = {
    pointerEvents: 'none',
};

const RawCurrentPosition = ({
    playing,
    baseTime,
    segments,
    segmentHeight,
    segmentMargin,
    segmentWidth,
    minutesPerSegment,
    streamPosition,
    ...styles
}: Props & RecomposeProps) => {
    const rawPos = (streamPosition - baseTime) / (minutesPerSegment * oneMinute);
    const segment = Math.floor(rawPos);
    const yOffset = segment * (segmentHeight + segmentMargin) + (segmentHeight / 2);
    const xOffset = (rawPos - segment) * segmentWidth;
    if (segment < 0 || segment >= segments) {
        return null;
    }
    return (
        <g
            style={ style }
            transform={ `translate(${xOffset || 0},${yOffset || 0})` }
        >
            <circle
                cx={ 0 }
                cy={ 0 }
                r={ segmentHeight * .6 }
                style={ styles.circleStyle }
            />
            { playing &&
                <path
                    d="M-2,-4 l6,4 l-6,4 z"
                    style={ styles.pathStyle }
                />
            }
            { !playing &&
                <path
                    d="M-4,-4 l3,0 0,8 -3,0 z M1,-4 l3,0 0,8 -3,0 z"
                    style={ styles.pathStyle }
                />
            }
        </g>
    );
};

type RecomposeProps = {
    circleStyle: React.CSSProperties;
    pathStyle: React.CSSProperties;
};

export const CurrentPosition = compose<Props & RecomposeProps, Props>(
    skin,
    withProps(({ styles }: OemProps) => ({
        circleStyle: {
            stroke: 'rgba(0,0,0,.5)',
            strokeWidth: '.5px',
            fill: styles.Accent.backgroundColor,
        },
        pathStyle: {
            stroke: 'rgba(0,0,0,.25)',
            strokeWidth: '.25px',
            fill: styles.Window.color,
        },
    })),
)(RawCurrentPosition);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/timeline/CurrentPosition.tsx